import { CommonModule, NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgModule,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fz-alert',
  standalone: true,
  template: `
    <mat-icon class="fz-alert__icon" *ngIf="!hideIcon">
      {{
        severity === 'success'
          ? 'check_circle_outlined'
          : severity === 'error'
            ? 'error_outlined'
            : severity === 'warning'
              ? 'warning_outlined'
              : 'info_outlined'
      }}
    </mat-icon>
    <ng-content select="fz-alert-message"></ng-content>
  `,
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: `fz-alert`,
    '[class.fz-alert--filled]': 'variant === "filled"',
    '[class.fz-alert--outlined]': 'variant === "outlined"',
    '[class.fz-alert--success]': 'severity === "success"',
    '[class.fz-alert--error]': 'severity === "error"',
    '[class.fz-alert--warning]': 'severity === "warning"',
    '[class.fz-alert--info]': 'severity === "info"',
  },
  imports: [CommonModule, NgClass, NgIf, MatIconModule],
})
export class AlertComponent {
  /**
   * Message to display in the alert
   */
  @Input() message: string;

  /**
   * Severity of the alert
   * @default 'success'
   * @type {'success' | 'error' | 'warning' | 'info'}
   */
  @Input() severity: 'success' | 'error' | 'warning' | 'info' = 'info';

  /**
   * Variant of the alert
   * @default 'filled'
   * @type {'filled' | 'outlined'}
   */
  @Input() variant: 'filled' | 'outlined';

  @Input() hideIcon: boolean;

  @Output() closed = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  onClose() {
    this.closed.emit();
  }
}

@Component({
  selector: 'fz-alert-icon',
  standalone: true,
  template: `
    <mat-icon class="fz-alert__icon">
      <ng-content select="fz-alert-icon"></ng-content>
    </mat-icon>
  `,
  imports: [MatIconModule],
})
export class AlertIconComponent {}

@Component({
  selector: 'fz-alert-title',
  standalone: true,
  template: `
    <p>
      <ng-content></ng-content>
    </p>
  `,
})
export class AlertTitleComponent {}

@Component({
  selector: 'fz-alert-message',
  standalone: true,
  template: `
    <div class="fz-alert__message">
      <ng-content select="fz-alert-title"></ng-content>
      <p class="mat-body-medium">
        <ng-content></ng-content>
      </p>
    </div>
  `,
})
export class AlertMessageComponent {}

@NgModule({
  imports: [
    AlertComponent,
    AlertIconComponent,
    AlertTitleComponent,
    AlertMessageComponent,
  ],
  exports: [
    AlertComponent,
    AlertIconComponent,
    AlertTitleComponent,
    AlertMessageComponent,
  ],
})
export class AlertModule {}
